



































import { Vue, Component } from "vue-property-decorator";

@Component
class Fixie extends Vue {
    public fixieStyles: any = {
        top: "100vh",
    };

    public mounted() {
        const self = this;
        const fixie = this.$el.querySelector(".bottom");
        let running = false;
        let h = 0;

        if (fixie) {
            window.addEventListener("resize", () => {
                if (!running) {
                    window.requestAnimationFrame(setPosition);
                }
            });

            setPosition();
        }

        function setPosition() {
            running = true;

            if (h !== window.innerHeight) {
                h = window.innerHeight;
                self.fixieStyles.top = `${h}px`;
                window.requestAnimationFrame(setPosition);
            } else {
                running = false;
            }
        }
    }
}

export default Fixie;



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fixie.vue